export const RESTRICTED_FEATURE_ERROR_CODE =
  "billing:error.capabilityUnavailable";

export const RESTRICTED_FEATURE_PROMPT_EVENT =
  "organization:restricted-feature-prompt";

export interface RestrictedFeaturePromptDetail {
  readonly featureName?: string;
  readonly title?: string;
  readonly description?: string;
}

export class RestrictedFeatureError extends Error {
  readonly code = RESTRICTED_FEATURE_ERROR_CODE;

  constructor(message = "This feature requires a paid organization subscription.") {
    super(message);
    this.name = "RestrictedFeatureError";
  }
}

const getErrorCode = (error: unknown): string | null => {
  if (!error || typeof error !== "object") return null;

  if ("code" in error && typeof error.code === "string") {
    return error.code;
  }

  if (
    "error" in error &&
    error.error &&
    typeof error.error === "object" &&
    "code" in error.error &&
    typeof error.error.code === "string"
  ) {
    return error.error.code;
  }

  return null;
};

export const isRestrictedFeatureError = (error: unknown) => {
  if (error instanceof RestrictedFeatureError) return true;
  return getErrorCode(error) === RESTRICTED_FEATURE_ERROR_CODE;
};

export const openRestrictedFeaturePrompt = (
  detail: RestrictedFeaturePromptDetail = {},
) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<RestrictedFeaturePromptDetail>(
      RESTRICTED_FEATURE_PROMPT_EVENT,
      { detail },
    ),
  );
};

export const handleRestrictedFeatureError = (
  error: unknown,
  detail: RestrictedFeaturePromptDetail = {},
) => {
  if (!isRestrictedFeatureError(error)) return false;
  openRestrictedFeaturePrompt(detail);
  return true;
};
